<script>
	import Painel from './Painel.svelte';
	
	const opcoes = [
		{
			titulo: "Início", 
			icone: "inicio",
			link: "#/",
			perfis: "CETREINA,AVALIADOR,DISCENTE,COORDENADOR"
		},
		{ 
			titulo: "Projetos", 
			icone: "projeto",
			link: "#/painel/projetos",
			perfis: "CETREINA,COORDENADOR,DISCENTE"
		},
		{ 
			titulo: "Usuários", 
			icone: "usuario",
			link: "#/painel/usuarios",
			perfis: "CETREINA,AVALIADOR,DISCENTE,COORDENADOR"		
		},
		{
			titulo: "Distribuição", 
			icone: "distribuicao",
			link: "#/painel/distribuicao",
			perfis: "CETREINA"
		},
		{
			titulo: "Distribuição", 
			icone: "distribuicao",
			link: "#/distribuicao/listagem-aguardando-aceite",
			perfis: "AVALIADOR"
		},
		{
			titulo: "Avaliação", 
			icone: "avaliacao",
			link: "#/painel/avaliacao",
			perfis: "CETREINA,AVALIADOR"
		},
		{
			titulo: "Banco Afirm.", 
			icone: "banco_afirmacoes",
			link: "#/painel/banco-afirmacoes",
			perfis: "CETREINA"
		},
		{
			titulo: "Grupos", 
			icone: "grupo",
			link: "#/painel/grupos",
			perfis: "CETREINA"
		},
		{
			titulo: "Classificação", 
			icone: "trofeu",
			link: "#/painel/classificacao",
			perfis: "CETREINA"
		},
		{ 
			titulo: "Bolsistas",
			icone: "bolsista",
			link: "#/projeto/bolsistas",
			perfis: "CETREINA"
		},
		{ 
			titulo: "Apresentações",
			icone: "apresentacao",
			link: "#/projeto/listagem/apresentacoes",
			perfis: "CETREINA"
		},
		{ 
			titulo: "Bolsista", 
			icone: "bolsista",
			link: "#/projeto/indicar-bolsista",
			perfis: "COORDENADOR"
		},
		{
			titulo: "Relatórios", 
			icone: "relatorio",
			link: "#/painel/relatorios",
			perfis: "CETREINA"
		},
		{
			titulo: "Configurações", 
			icone: "configuracao",
			link: "#/painel/configuracoes",
			perfis: "CETREINA,AVALIADOR,DISCENTE,COORDENADOR"
		},
		// {
		// 	titulo: "Mensagens", 
		// 	icone: "mensagens",
		// 	link: "#/painel/mensagens",
		// 	perfis: "CETREINA,AVALIADOR,DISCENTE,COORDENADOR"
		// },
	];
</script>

<Painel 
	titulo="Painel Principal" 
	listaFuncionalidades={opcoes}>
</Painel>
